/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FaxConfirmation
 */
export interface FaxConfirmation {
    /**
     * 
     * @type {string}
     * @memberof FaxConfirmation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FaxConfirmation
     */
    status: FaxConfirmationStatusEnum;
}


/**
 * @export
 */
export const FaxConfirmationStatusEnum = {
    Sending: 'Sending',
    Sent: 'Sent',
    SendingFailed: 'SendingFailed',
    Received: 'Received',
    Queued: 'Queued',
    Submitted: 'Submitted'
} as const;
export type FaxConfirmationStatusEnum = typeof FaxConfirmationStatusEnum[keyof typeof FaxConfirmationStatusEnum];


/**
 * Check if a given object implements the FaxConfirmation interface.
 */
export function instanceOfFaxConfirmation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function FaxConfirmationFromJSON(json: any): FaxConfirmation {
    return FaxConfirmationFromJSONTyped(json, false);
}

export function FaxConfirmationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FaxConfirmation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': json['status'],
    };
}

export function FaxConfirmationToJSON(value?: FaxConfirmation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'status': value.status,
    };
}

